import type { CreativeGrouping } from "@nexus/contracts"

import { DrilldownCreativeAdSpendPanel } from "../DrilldownCreativeAdSpendPanel"

import type { MyBrandFiltersInput } from "@/lib/queries/dashboard.queries"
import type { DrilldownPageFiltersInput } from "@/lib/queries/drilldown.queries"

interface DrilldownMyBrandCreativeAdIdsTabProps {
  hash: string
  grouping: CreativeGrouping
  myBrandFilters: MyBrandFiltersInput
  drilldownFilters: DrilldownPageFiltersInput
  currencySymbol: string
}

export function DrilldownMyBrandCreativeAdIdsTab({
  hash,
  grouping,
  myBrandFilters,
  drilldownFilters,
  currencySymbol,
}: DrilldownMyBrandCreativeAdIdsTabProps) {
  return (
    <div className="flex flex-col gap-5 px-6 py-5">
      <DrilldownCreativeAdSpendPanel
        hash={hash}
        grouping={grouping}
        variant="inline"
        myBrandFilters={myBrandFilters}
        drilldownFilters={drilldownFilters}
        currencySymbol={currencySymbol}
      />
    </div>
  )
}
